import { useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';

import CancelationModal from 'features/account/my-plan/CancelationModal';
import Button from 'honeydew/Button';
import Card from 'honeydew/Card';
import Tag from 'honeydew/Tag';
import { trackEvent } from 'utils/analyticsUtils';
import { openModal } from 'utils/globalUtils';

function CancelationModule({ account, autoShip, openUpgradeModal, setSuccess, subscription }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [cancelationModal, setCancelationModal] = useState(false);
    const [cancelationStep, setCancelationStep] = useState('pause');

    const openCancelationModal = () => {
        openModal(setCancelationModal);
        trackEvent('account cancel start');
    };

    const handleSkipUpcomingOrdersClick = () => {
        navigate('/account/upcoming-deliveries');
        trackEvent('skip upcoming orders click', { path: location.pathname });
    };

    const handleOpenHardCancelModal = () => {
        openCancelationModal();
        setCancelationStep('hard-cancel');
        trackEvent('flex plan cancel start');
    };

    return (
        <Card marginClasses="mt-20">
            <div className="grow gap-70 md:flex">
                <h2 className="text-body-lg mb-20 font-grotesk-bold md:min-w-[180px]">
                    {autoShip ? 'Need a break?' : 'Manage Plan'}
                </h2>

                {autoShip ? (
                    <div>
                        <div className="pb-10">
                            <Tag bgColor="lime" variant="dark">
                                GROCERY SUBSCRIPTION
                            </Tag>
                        </div>
                        <p>You can skip an upcoming order, pause your plan, or cancel your subscription.</p>
                        <div className="text-body-sm mb-10 mt-20 w-[220px]">
                            <Button size="md" variant="secondary" onClick={handleSkipUpcomingOrdersClick}>
                                Skip an order
                            </Button>
                        </div>
                        <button type="button" className="link text-body-sm" onClick={openCancelationModal}>
                            Pause or cancel subscription
                        </button>
                    </div>
                ) : (
                    <div>
                        <div className="pb-10">
                            <Tag bgColor="lime" variant="dark">
                                FLEX PLAN
                            </Tag>
                        </div>
                        <p>Missing the convenience of a grocery subscription?</p>
                        <div className="text-body-sm mb-10 mt-20 w-[220px]">
                            <Button size="md" variant="secondary" onClick={openUpgradeModal}>
                                Upgrade plan
                            </Button>
                        </div>
                        <button type="button" className="link text-body-sm" onClick={handleOpenHardCancelModal}>
                            Cancel account
                        </button>
                    </div>
                )}
            </div>

            <CancelationModal
                account={account}
                cancelationModal={cancelationModal}
                setCancelationModal={setCancelationModal}
                setSuccess={setSuccess}
                subscription={subscription}
                cancelationStep={cancelationStep}
                setCancelationStep={setCancelationStep}
            />
        </Card>
    );
}

CancelationModule.propTypes = {
    account: PropTypes.shape({}),
    autoShip: PropTypes.bool.isRequired,
    openUpgradeModal: PropTypes.func.isRequired,
    setSuccess: PropTypes.func.isRequired,
    subscription: PropTypes.shape({}),
};

CancelationModule.defaultProps = {
    account: {},
    subscription: {},
};

export default CancelationModule;
